import React from 'react';
import { useStaticQuery, graphql } from "gatsby";
import SectionContent from "./../scripts/sectionContent";

const Contact = () => {

    const data = useStaticQuery(graphql`
        query contactSectionQuery {
            allContentfulSectionContent(filter: {section: {eq: "Contact"}, page: {eq: "Homepage"}}) {
                edges {
                    node {
                        id
                        content {
                            childMarkdownRemark {
                                html
                                rawMarkdownBody
                            }
                        }
                        contentType
                    }
                }
            }
        }
    `);

    const sectionContent = new SectionContent(data.allContentfulSectionContent);

    return (
        <section id="contact" className="contact section container mx-auto">
            <div className="flex">
                <div className="col w-full md:w-6/12 mx-auto text-center">
                    <h4 className="section__heading text-2xl  mx-auto mb-4">{ sectionContent.getContent('heading').rawMarkdownBody }</h4>
                    <p className="mb-16">{ sectionContent.getContent('description').rawMarkdownBody }</p>
                    <form id="contact-form" action="#" className="text-left shadow-lg border border-gray-100 px-8 py-12" data-netlify="true">
                        <div className="form-group mb-6">
                            <label htmlFor="name">Full Name</label>
                            <input type="text" id="name" className="input" name="name" />
                        </div>
                        <div className="form-group mb-6">
                            <label htmlFor="email">Email</label>
                            <input type="email" id="email" className="input" name="email" />
                        </div>
                        <div className="form-group mb-8">
                            <label htmlFor="message">Message</label>
                            <textarea id="message" className="input h-32" name="message"></textarea>
                        </div>
                        <button type="submit" className="btn btn--primary btn--full">Submit</button>
                    </form>
                </div>
            </div>
        </section>
    );
    
}
export default Contact;
